import { apiConstants } from "../_constants";
import { authHeader, handleResponse } from "../_helpers";
export const courseService = {
    courseList,
    courseDelete,
    getCourseWithSubjects,
};

function courseList(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getcourselist", requestOptions).then(
        handleResponse
    );
}
function getCourseWithSubjects(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(
        apiConstants.apiUrl + "/getcoursewithsubjects",
        requestOptions
    ).then(handleResponse);
}
function courseDelete(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/deletecourse", requestOptions).then(
        handleResponse
    );
}
